<template>
    <transition name="fade">
        <div class="modal is-active" v-if="value">
            <div
                class="modal-background"
                @click="!isNotCloseable && close()"
            ></div>
            <div class="modal-content">
                <slot></slot>
            </div>
            <button
                v-if="!isNotCloseable"
                class="modal-close is-large"
                aria-label="close"
                @click="close()"
            ></button>
        </div>
    </transition>
</template>

<script>
import { eventBus } from '../../events/event-bus';

export default {
    name: 'ModalView',
    props: {
        isNotCloseable: {
            required: false,
        },
        transition: {
            type: String,
            required: false,
            default: 'fade',
        },
        value: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
    },
    watch: {
        value: function (val) {
            let $body = document.querySelector('body');
            if (val === true) {
                $body.classList.add('is-clipped');
            } else {
                $body.classList.remove('is-clipped');
            }
        },
    },
    created() {
        eventBus.$on('close-modal-event', () => {
            this.close();
        });
    },
    mounted() {
        let $body = document.querySelector('body');
        if (this.isOpen === true) {
            $body.classList.add('is-clipped');
        }
    },
};
</script>

<style scoped></style>
